/**
 * Base URL for Flightdeck
 */
export const FLIGHTDECK_BASE_URL = 'https://app.flightdeck.cio.host';
